import CryptoJS from 'crypto-js';

// Secret key for encryption - should be stored securely in production
const SECRET_KEY = process.env.VUE_APP_STORAGE_SECRET_KEY || 'verbum-script-default-key-2024';

/**
 * Encrypt data before storing
 * @param {any} data - Data to encrypt
 * @returns {string} Encrypted string
 */
function encrypt(data) {
    try {
        const jsonString = JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
        return encrypted;
    } catch (error) {
        console.error('Encryption error:', error);
        throw new Error('Failed to encrypt data');
    }
}

/**
 * Decrypt data after retrieving
 * @param {string} encryptedData - Encrypted string
 * @returns {any} Decrypted data
 */
function decrypt(encryptedData) {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedString);
    } catch (error) {
        console.error('Decryption error:', error);
        return null;
    }
}

/**
 * Secure localStorage wrapper with encryption
 */
const secureStorage = {
    /**
     * Set item in localStorage with encryption
     * @param {string} key - Storage key
     * @param {any} value - Value to store (will be JSON stringified and encrypted)
     */
    setItem(key, value) {
        try {
            const encrypted = encrypt(value);
            localStorage.setItem(key, encrypted);
        } catch (error) {
            console.error('SecureStorage setItem error:', error);
            throw error;
        }
    },

    /**
     * Get item from localStorage with decryption
     * @param {string} key - Storage key
     * @returns {any} Decrypted value or null if not found
     */
    getItem(key) {
        try {
            const encrypted = localStorage.getItem(key);
            if (!encrypted) return null;

            return decrypt(encrypted);
        } catch (error) {
            console.error('SecureStorage getItem error:', error);
            return null;
        }
    },

    /**
     * Remove item from localStorage
     * @param {string} key - Storage key
     */
    removeItem(key) {
        localStorage.removeItem(key);
    },

    /**
     * Clear all localStorage
     */
    clear() {
        localStorage.clear();
    },

    /**
     * Check if key exists in localStorage
     * @param {string} key - Storage key
     * @returns {boolean}
     */
    hasItem(key) {
        return localStorage.getItem(key) !== null;
    }
};

export default secureStorage;
